export const isValidLocationObject = (value: unknown): value is {value: unknown; label: string} => {
    return typeof value === "object" && Object.prototype.hasOwnProperty.call(value, "value") && Object.prototype.hasOwnProperty.call(value, "label");
};
export const isValidLocationObject = (value: unknown): value is {value: unknown; label: string} => {
    return typeof value === "object" && Object.prototype.hasOwnProperty.call(value, "value") && Object.prototype.hasOwnProperty.call(value, "label");
};
